module.exports = __webpack_public_path__ + "img/useradmin_bg.58c6da5d.jpg";